import { getDailyPricesSum } from './getDailyPricesSum'
import { getTotalAdultsPrice } from './getTotalAdultsPrice'
import { getTotalChildrenPrice } from './getTotalChildrenPrice'
import { getNights } from 'Rentlio/state/selectors/request'
import { paymentTypes } from 'Rentlio/utils/services'
import { servicePricingTypeEnum } from 'Rentlio/utils/servicePricingTypeEnum'

function getServiceCostLegacy(service, request) {
  const { price, quantity, paymentType, isMandatory } = service
  if (isMandatory) {
    // mandatory services use real price model that
    // was already applied for getting correct quantity
    return quantity * price
  }

  const nights = getNights(request)
  switch (paymentType) {
    case paymentTypes.PER_PERSON:
    case paymentTypes.PER_ADULT:
    case paymentTypes.PER_CHILDREN_UNDER_12:
    case paymentTypes.PER_CHILDREN_ABOVE_12:
    case paymentTypes.ONE_TIME_FEE:
      return quantity * price
    case paymentTypes.PER_NIGHT:
    case paymentTypes.PER_PERSON_PER_NIGHT:
      return nights * price * quantity
  }

  // if paymentType = 0
  return quantity * price
}

function getServiceCostWithPricingDynamic(service, request) {
  const { dailyPrices, quantity, pricingType } = service

  const basePrice = getDailyPricesSum(dailyPrices)

  if (pricingType === servicePricingTypeEnum.PER_PERSON) {
    const priceForAdults = getTotalAdultsPrice(basePrice, request, service)
    const childrenPrice = getTotalChildrenPrice(basePrice, request, service)

    return quantity * (priceForAdults + childrenPrice)
  }

  return quantity * basePrice
}

export function getServiceCosts(service, request) {
  const { paymentType } = service

  if (typeof paymentType !== 'undefined' && paymentType !== null) {
    return getServiceCostLegacy(service, request)
  }

  return getServiceCostWithPricingDynamic(service, request)
}
